module.exports = __webpack_public_path__ + "img/01a_Pinterest_651px.5a809f91.jpg";